<template>
  <mastery-modal
    :name="modalName"
    type="masteryModalWhite"
    :header-image="headerImage"
    :header-image-size="'small'"
    :max-width="372"
    :primary-action-text="primaryText"
    :secondary-action-text="secondaryText"
    @before-open="beforeOpen"
    @close-fn="handleModalClose"
    @primary-action-clicked="activatePurchaseReceipt"
    @secondary-action-clicked="dismissedModal"
  >
    <div
      v-if="purchaseReceipt"
      class="modal-body"
    >
      <p class="call-to-action">
        {{ ctaText }}
      </p>
      <p class="body-text">
        {{ bodyText }}
      </p>
    </div>
  </mastery-modal>
</template>

<script>
import MasteryModal from '@/components/ui/masteryModal.vue';
export default {
  name: 'DelayedPurchaseModal',
  components: { MasteryModal },
  data() {
    return {
      dashboard: null,
      purchaseReceipt: null,
    };
  },
  computed: {
    analyticsParams() {
      return {
        source: {
          id: this.dashboard?.id,
          name: this.dashboard?.name,
          type: 'Dashboard',
        },
        po: this.purchaseOrder,
      };
    },
    bodyText() {
      let modifier = ' ';
      if (this.purchaseOrder?.daysUntilExpiration) {
        modifier = ` ${this.purchaseOrder.daysUntilExpiration} days worth of `;
      }
      return `Hit the button to start using that${modifier}exam prep you paid for.`;
    },
    ctaText() {
      return 'Is It Go Time?';
    },
    headerImage() {
      return 'delayed-purchase-calendar.svg';
    },
    modalName() {
      return 'delayed-purchase-modal';
    },
    purchaseOrder() {
      if (this.purchaseReceipt) {
        return this.$store.getters['purchaseOrders/get'][this.purchaseReceipt.purchaseOrderId];
      }
    },
    primaryText() {
      return 'Ready to activate';
    },
    secondaryText() {
      return 'Not Yet';
    },
  },
  methods: {
    activatePurchaseReceipt() {
      this.$analytics.events.activatedDelayedPurchase(this.analyticsParams);
      this.$store
        .dispatch('purchaseReceipts/activate', { id: this.purchaseReceipt?.id })
        .then(() => {
          this.closeModal();
        });
    },
    beforeOpen(event) {
      if (event?.params) {
        this.dashboard = event.params.dashboard;
        this.purchaseReceipt = event.params.purchaseReceipt;
        this.$nextTick().then(() => this.$analytics.events.viewedDelayedPurchaseModal(this.analyticsParams));
      }
    },
    closeModal() {
      this.$modal.hide(this.modalName);
    },
    dismissedModal() {
      this.$analytics.events.selectedLaterOnDelayedPurchase(this.analyticsParams);
      this.closeModal();
    },
    handleModalClose() {
      this.dashboard = null;
      this.purchaseReceipt = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-body {
  text-align: center;

  .call-to-action,
  .body-text {
    margin: 0;
  }

  .call-to-action {
    font-weight: $bold;
    font-size: rem-calc(26);
  }

  .body-text {
    font-size: rem-calc(16);
    line-height: 1.5;
    margin-top: rem-calc(8);
  }
}
</style>
